import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { Utilities_ModuleContextService } from './Utilities.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class Utilities_open_toaster_frontflow_ComponentContextService {
  private readonly moduleContext: Utilities_ModuleContextService;

  constructor(moduleContext: Utilities_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'open_toaster_frontflow',
      type: ComponentType.frontendFlow
    }
  }
}